import { SDrawerOrModal } from 'shj-components'
import styles from './index.module.less'
import { Tabs, Image, Tooltip, message, Button, Spin } from 'antd'
import ProductDeatail from '../ProductDeatail'
import { useEffect, useRef, useState } from 'react'
import { CopyOutlined, RightOutlined } from '@ant-design/icons'
import ChevronRight from '@/assets/ChevronRight.png'
import SubSpaceApply from '../SubSpaceApply'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import { cloneDeep } from 'lodash-es'
import { saveBudgetDtl, subtractSearch } from '@/services/order'
import _, { isEmpty } from 'lodash'
export default function SubComfirmModal(props: any) {
  const { open, setOpen, record, spaceId, type, budgetId, generalId, btnInfo, reload } = props
  const [combinationPrice, setCombinationPrice] = useState<any>(undefined) // 组合确定sku价格
  const [modifyCurrentSku, setModifyCurrentSku] = useState<any>({}) // 多规格确定sku信息
  const [materialDynaOptions, setMaterialDynaOptions] = useState<any>({}) // 报价属性信息
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])
  const [submitData, setSubmitData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)
  const [spaceLoading, setSpaceLoading] = useState<boolean>(false)
  const [subPriceAll, setSubPriceAll] = useState<any>(undefined)
  const [items, setItems] = useState<any>([])
  const spaceRef = useRef<any>(null)
  const submitDataRef = useRef<any>({})
  submitDataRef.current = submitData

  useEffect(() => {
    console.log(record, 'record')
    let newData = cloneDeep(record || {})
    if (type === 'SUB') {
      setSpaceLoading(true)
      // 减项 需要塞入所有空间信息
      subtractSearch({
        data: {
          skuId: newData?.productSku?.id || null,
          generalId: newData?.generalItemManageId || null,
          quoteBudgetId: budgetId,
          prodType: null,
          type: 'SUB',
        },
      })
        .then((res: any) => {
          if (res && res?.length) {
            res = res.map(item => {
              item.list = [
                {
                  itemId: item?.budgetItemList[0]?.id, // 空间标识id,
                  remark: '',
                  budgetQtyValue: '',
                  budgetQtyFormular: '',
                },
              ]
              return {
                ...item,
              }
            })
            console.log(res, 'res')
            newData.list = res
            setSubmitData({ ...newData })
          }
        })
        .finally(() => {
          setSpaceLoading(false)
        })
    }
  }, [record])
  useEffect(() => {
    console.log(combinationPrice, 'combinationPrice')
  }, [combinationPrice])
  useEffect(() => {
    console.log(modifyCurrentSku, 'modifyCurrentSku多规格确定sku后的信息')
    // 选材之后确定SKU码
    if (!isEmpty(modifyCurrentSku)) {
      submitData.dynaOptions = modifyCurrentSku.argMap
      submitData.productSkuName = modifyCurrentSku.skuName
      submitData.productSkuSalePrice = modifyCurrentSku.priceInfo?.customerPrice
      submitData.productSkuId = modifyCurrentSku.id
      submitData.longDesc = modifyCurrentSku?.longDesc
      submitData.productSpuPrimaryImage =
        modifyCurrentSku?.mainPicUrl || submitData?.productSpuPrimaryImage
      setSubmitData({ ...submitData })
    }
  }, [modifyCurrentSku])
  const handleLongDesc = data => {
    // 子产品有且只有一个为来源物料 工艺说明为该子产品的sku的工艺说明
    let materialList = data?.filter(
      (item: any) => item?.product?.sourceType === 'MATERIAL' && item?.checked
    )
    if (materialList.length === 1) {
      let skuInfo = materialList[0]?.skuList?.find(
        (el: any) => el.id === materialList[0]?.selectSkuId
      )
      return skuInfo?.longDesc
    } else {
      return ''
    }
  }
  const confirmInfo = (combinationInfoDetail: any) => {
    if (combinationInfoDetail && combinationInfoDetail?.length) {
      // 确认组合信息
      const hasSkuList = combinationInfoDetail.filter(item => item.selectSkuId)
      const hasCheckedList = combinationInfoDetail.filter(item => item.checked)
      // const
      let noSkuProdInfo: any = {}
      if (hasSkuList?.length !== hasCheckedList?.length) {
        noSkuProdInfo = hasCheckedList?.filter(item => !item.selectSkuId)?.[0]
        // message.error(
        //   `产品SPU：${noSkuProdInfo?.prodName}-${noSkuProdInfo?.id}未对应上SKU，请检查，可能原因：①没有适用该门店的SKU；②未选择商品规格`
        // )
        return
      }

      let newData = cloneDeep(submitDataRef.current || {})
      let longDesc = ''
      longDesc = handleLongDesc(combinationInfoDetail)
      newData.packDtlList = combinationInfoDetail
      newData.productSkuSalePrice =
        combinationPrice || combinationPrice === 0
          ? combinationPrice
          : submitData.productSkuSalePrice
      newData.longDesc = longDesc
      console.log(combinationInfoDetail, '组合数据')
      setSubmitData({ ...submitDataRef.current, ...newData })
    }
  }

  useEffect(() => {
    if (materialDynaOptions && materialDynaOptions?.length) {
      console.log(materialDynaOptions, 'materialDynaOptions')
      if (materialDynaOptions?.every(item => item?.optionId)) {
        // 所有报价属性都选中才提交
        submitData.materialDynaOptions = materialDynaOptions
        setSubmitData({ ...submitData })
      }
    }
  }, [materialDynaOptions])
  const onChange = (key: string) => {
    console.log(key)
  }
  const clickToCopy = value => {
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = value
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    message.success('复制成功', 1)
  }
  const clickToDetail = record => {
    window.open(`/order/materialSelectionLibrary/materialDetail/${record?.productId}`, '_blank')
  }
  const priceHandle = price => {
    if (price) {
      let priceStr = numFormat({ value: price })
      const [int, dec] = priceStr.split('.')

      if (Number(dec)) {
        return (
          <>
            <span>{int}</span>
            <span className={styles.priceBoxSmall}>.{dec}</span>
          </>
        )
      } else {
        return <span>{int}</span>
      }
    } else if (price == 0) {
      return <span>{0}</span>
    }
  }
  const handleSubmit = () => {
    console.log(submitData, 'submitData')
    const submitList = postData(submitData)
    if (!submitList?.length) {
      message.error('请勾选应用空间')
      return
    }
    setLoading(true)
    // 以数组形式提交
    saveBudgetDtl({
      data: submitList,
    })
      .then((res: any) => {
        console.log(res)
        if (res && res.length) {
          message.error('提交失败')
        } else {
          message.success('提交成功')
          reload?.()
          setOpen(false)
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }
  const postData = item => {
    console.log(item, 'item')
    let spaceData = spaceRef.current?.spaceData
    console.log(spaceRef.current?.spaceData, 'spaceRef.current?.spaceData')
    if (spaceData?.length) {
      spaceData.map((item: any) => {
        item.quoteBudgetId = budgetId
        item.refItemId = btnInfo?.id

        item.type = type // 为通项传值
        // item.addType = currentSearchParams.sourceType || null
        // 空间明细字段处理
        if (item?.list && item?.list.length) {
          item.spaceChecked = item?.list.map(el => el.itemId)
        }

        if (type === 'SUB') {
          item?.list?.forEach((el: any) => {
            el.reduceSourceBudgetDtlId = item.referenceId
            el.budgetQtyValue = item.budgetQtyValue
            el.budgetQtyFormular = item.budgetQtyFormular
            el.remark = item.remark
          })
        }
        // }
        if (
          (type === 'ADD' && !item.budgetItemList?.length) ||
          (type === 'SUB' && !item.budgetItemList?.length) ||
          (type === 'PROJECT' && !item.budgetItemList?.length)
        ) {
          // 无空间信息 但有一条预算量计算式
          const array: any = []
          array.push({
            itemId: spaceId,
            remark: item.remark || '',
            budgetQtyValue: item.budgetQtyValue,
            budgetQtyFormular: item.budgetQtyFormular || '',
          })
          item.list = array
        }
        item.dynaOptions = item.dynaOptions ? item.dynaOptions : item.productSku?.argMap
        // 处理产品明细
        if (item.packDtlList?.length) {
          item.packDtlList = item.packDtlList.filter(el => el.selectSkuId)
        }
        // 每种类型特殊字段处理
        switch (item.type) {
          case 'ACTIVITY':
            item.activityId = item.activity?.id
            item.activityProductId = item.activityProduct?.id
            delete item.generalId
            break
          case 'UP_DOWN':
            // 升降级 需要传参通项Id
            // item.generalId = currentSearchParams.generalId // 通项id
            break
          case 'SUB':
            item.reduceSourceBudgetDtlId = item.referenceId
            item.generalId = item.generalItemManageId
            break
          case 'ADD':
            item.generalId = item.generalItemManageId
            break
          default:
            break
        }
      })
    }

    return spaceData
  }
  const handlePriceBox = () => {
    // let price =
    //   modifyCurrentSku?.priceInfo?.customerPrice ?? combinationPrice ?? record?.productSkuSalePrice
    // if (record?.materialDynaOptions?.length || record?.skuDynamicVoList?.length) {
    //   price = record?.saleCustPrice ?? record?.productSkuSalePrice
    // }

    return priceHandle(subPriceAll)
  }
  return (
    <SDrawerOrModal
      open={open}
      onCancel={() => {
        setOpen(false)
      }}
      width={1000}
      mode="modal"
      title={'减项'}
      antdProps={{
        footer: (
          <div className={styles.footer}>
            <div className={styles.priceBox}>
              <span>
                已选择<span className={styles.priceBoxSmall}>{selectedRowKeys?.length}</span>项
              </span>
            </div>
            <div>
              <div className={styles.btnBox}>
                <div className={styles.priceBox}>
                  <span className={styles.total_class}>合计：</span>

                  <span className={styles.priceBoxSmall}>￥</span>
                  {handlePriceBox() || 0}
                  {record?.productSpuUnitName && (
                    <span className={styles.priceBoxSmall}>/{record?.productSpuUnitName}</span>
                  )}
                </div>
                <Button
                  onClick={() => {
                    setOpen(false)
                  }}
                  loading={loading}
                >
                  取消
                </Button>
                <Button
                  loading={loading}
                  type="primary"
                  onClick={handleSubmit}
                  style={{ marginLeft: '8px' }}
                >
                  确认减项
                </Button>
              </div>
            </div>
          </div>
        ),
        centered: true,
      }}
    >
      <div className={styles.productListContainer_Modal}>
        <Spin spinning={loading}>
          {record?.onlyShowTitle ? (
            <p className={styles.onlyShowTitle}>{record.referenceName}</p>
          ) : (
            <div className={styles.mainBox}>
              <div className={styles.imgBox}>
                <Image.PreviewGroup items={record?.product?.imageUrls || undefined}>
                  <Image src={record?.productSpuPrimaryImage} className={styles.img} />
                </Image.PreviewGroup>
              </div>
              <div className={styles.infoBox}>
                <div className={styles.titleBox}>
                  <Tooltip title={record?.referenceName} placement="topLeft">
                    <div className={styles.title}>{record?.referenceName}</div>
                  </Tooltip>
                  <p className={styles.spuBox}>
                    <span>SKU：</span>
                    {record?.productSkuId}
                    <CopyOutlined
                      style={{ marginLeft: '8px' }}
                      className="copyIcon"
                      onClick={() => {
                        clickToCopy(record?.productSkuId)
                      }}
                    />
                  </p>
                  <div className={styles.checkoutBtn} onClick={() => clickToDetail(record)}>
                    <p>查看商品详情</p>
                    <img src={ChevronRight} alt="" />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div>
            <SubSpaceApply
              type={type}
              ref={spaceRef}
              submitData={submitData}
              spaceId={spaceId}
              loading={spaceLoading}
              selectedRowKeys={selectedRowKeys}
              setSelectedRowKeys={setSelectedRowKeys}
              setSubPriceAll={setSubPriceAll}
            ></SubSpaceApply>
          </div>
        </Spin>
      </div>
    </SDrawerOrModal>
  )
}
